import {Injectable} from '@angular/core'
import {Observable} from 'rxjs'

import {
  ContractService,
  Contract,
  UpdateContractEntryRequest,
} from '@app/core/services/contract/contract.service'
import {GenericManagerService} from '@app/core/services/generic-manager.service'
import {NotificationService} from '@app/core/services/notification.service'
import {LoggerService} from '@app/core/services/logger.service'

@Injectable()
export class ContractManagerService extends GenericManagerService<Contract> {
  domain

  constructor(
    private contractService: ContractService,
    protected notify: NotificationService,
    protected logger: LoggerService,
  ) {
    super(notify, logger)
  }

  retrieve(id: number): Observable<Contract> {
    return this.contractService.getContract(this.domain, id)
  }

  retrieveId(contract: Contract): any {
    return contract.id
  }

  doUpdate(id: any, contract: Contract): Observable<Contract> {
    return this.contractService.putContract(this.domain, contract)
  }

  doCreate(contract: Contract): Observable<Contract> {
    return this.contractService.postContract(this.domain, contract)
  }

  doDelete(id: any, force = false): Observable<void> {
    return this.contractService.deleteContract(this.domain, id, force)
  }

  updateEntries(entries: UpdateContractEntryRequest[]) {
    return this.contractService.patchContractEntries(
      this.domain,
      this.id,
      entries,
    )
  }

  doDeleteEntry(contract: number, id: number) {
    return this.contractService.deleteContractEntry(this.domain, contract, id)
  }

  mergeContract(contract: Contract, contractsToMerge: Contract[]) {
    return this.contractService.postAction(
      this.domain,
      contract.id,
      {
        name: 'merge-contracts',
        parameters: {
          contracts: contractsToMerge.map((item) => item.id),
        },
      },
      true,
    )
  }
}
